module.exports = __webpack_public_path__ + "img/key.e152b79a.svg";